/**
 * Chip that indicates whether queue has prioritization enabled.
 */

import {MOON_300, MOON_600} from '@wandb/weave/common/css/globals.styles';
import React from 'react';

import {Chip} from '../Chip';

export const PrioritizationChip = () => (
  <Chip
    icon="checkmark"
    label="Prioritization"
    color={MOON_600}
    backgroundColor={MOON_300}
  />
);
